// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RJm-","largestCol":"styles_largestCol__TiWQY","smallestCol":"styles_smallestCol__29-hT"};